import React, {useLayoutEffect, useState} from 'react';
import Radium from 'radium';
import useReduceStore from 'hooks/ReduceStoreHook';
import AppConstants from 'AppConstants';
import AppUtil from 'AppUtil';
import {A, Button, Img, Separator} from 'views/AppElements';
import Dispatcher from 'service/Dispatcher';

import ProductUtil from 'util/ProductUtil';
import Divider from 'muicss/lib/react/divider';

import SessionStore from 'stores/SessionStore';
import CacheService from 'service/CacheService';
import OrderAPI from 'service/api/OrderAPI';
import SelectedImagePreview from 'views/product/SelectedImagePreview';
import PhotoFrameImg from 'views/order/PhotoFrameImg';

const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;
const DELIVERY_TYPE = AppConstants.DELIVERY_TYPE;

const DELIVERY_LOCATION_TYPE = AppConstants.DELIVERY_LOCATION_TYPE;
const USER_TYPE = AppConstants.USER_TYPE;

const PAYMENT_OPTIONS = AppConstants.PAYMENT_OPTIONS;
const ORDER_TO_CONFIRM = 0, PROCEED_TO_PAY = 1, ORDER_CONFIRMED = 2, ORDER_PLACED = 3;

const h2Style = {fontSize: '175%', margin: '10px 0', '@media (max-width: 350px)': { fontSize: '150%'}};
const h3Style = {margin: '15px 0', fontSize: '115%'};
const h4Style = {fontSize: '110%', whiteSpace: 'pre-line', wordBreak: 'break-word'};

const LoginSignUpBtn = () => {

    return <div style={{marginRight: "140px", fontSize: '15px', 
                        '@media (max-width: 770px)': {textAlign: 'center', marginRight: '0px', fontSize: '17px'}}}>
                <div style={{margin: '20px 40px 20px 0', '@media (max-width: 770px)': {margin: '20px'}}}>- OR -</div>
                <div style={{color: 'gray'}}>
                <i className="fa fa-lock" aria-hidden="true"></i> <A href="#" style={{color: 'gray', '@media (max-width: 770px)': {flexGrow: '1'}}}
                        onClick={() => Dispatcher.dispatchAlertWithAction(AppConstants.LOGIN_TO_CONTINUE_MSG, "WARN")}>Login / Sign Up</A>

                </div>
        </div>
};

const OrderImage = Radium(({product, order, productType, customerImage}) => {
    const sizeStr  = AppUtil.getOrderSizeString(order, product);
	
    const isCustomPhotoFrame = AppUtil.isCustomProduct(product) && product.productType === PRODUCT_TYPES['PHOTO_FRAME'].val;
    const orderMetaData = order.orderMetaData || {};

    return <React.Fragment>
            {
                customerImage && isCustomPhotoFrame &&
                <PhotoFrameImg id="customerUploadedImgPreview" className="largeImg"  
                                                imgFile={customerImage}
                                                matting={orderMetaData['matting']} 
                                                borderColor={orderMetaData['borderColor']} />
            }
            {
                customerImage && !isCustomPhotoFrame &&
                <SelectedImagePreview id="customerUploadedImgPreview" file={customerImage} className="largeImg" />

            }

            {!customerImage && 
                <Img src={order.orderedProductImage} className="largeImg" />
            }
            
            <h3 style={[h3Style]}>{sizeStr}, <b>{product.title}</b> {(product.title.indexOf(productType.label)) < 0? productType.label: ''}</h3>
        </React.Fragment>
});

const OrderMetaData = Radium(({orderMetaData}) => {
    if(!orderMetaData) return null;

	const metaDataList = Object.keys(orderMetaData).map((k, i) => {
		const valueString = orderMetaData[k] instanceof Object? JSON.stringify(orderMetaData[k]): orderMetaData[k].toString();
		return <span key={i+"_"+k}><b>{k.toUpperCase()}</b> {": " + valueString}</span>;
	});

    return <div className="flexColumn orderMetaDataInfo">{metaDataList}</div>
});

const OrderAmount = Radium(({product, order, discountCoupon}) => {
    const productSizes = AppUtil.getSizeInfo(product);
    const productSizeOptions = order.sizeMetaData || productSizes;

    let totalPrice = null;
    if(order.isBulkOrder) {
        const discountPct = AppConstants.BULK_ORDER_DISCOUNT_PCT;
        totalPrice = Object.keys(order.sizeQuantity).map((size) => {
            const quantity = order.sizeQuantity[size];
            const perPrice = (product.price + productSizeOptions[size].priceAddition) * (1 - discountPct);

            return quantity * perPrice;
        }).reduce((p1, p2) => {
            return p1 + p2;
        }, 0);
        
    } else {
        const perPrice = product.price + productSizeOptions[order.productSizes[0]].priceAddition;
        totalPrice = perPrice * order.quantity;
    }
    

    const locationExtraCost = order.deliveryCharge;
    const deliveryTypeExtraCost = DELIVERY_TYPE[order.deliveryType].extraCost;

    const productVariants = product.productVariants;

    const selectedVariants = ProductUtil.getSelectedVariants(productVariants, order.selectedVariants);

    let variantExtraCost = 0;

    selectedVariants.forEach(vr => {
        const priceAddition = vr.priceAddition || 0;
        variantExtraCost += priceAddition;
    });


    const totalExtraCost = locationExtraCost + deliveryTypeExtraCost + variantExtraCost;


    let discountAmount = 0;
    if(discountCoupon && discountCoupon.discountPct) {
        discountAmount = discountCoupon.discountPct * totalPrice;
    } else if (discountCoupon && discountCoupon.discountAmount) {
        discountAmount = discountAmount * order.quantity;
    }
    const totalAmount = (totalPrice + totalExtraCost) - discountAmount;

    const paymentInfo = PAYMENT_OPTIONS[order.paymentPreference].label;

    return <React.Fragment>
            {
                (totalExtraCost > 0 || discountAmount > 0) &&
                <div>
                    <h2>Cost Detail</h2>	
                    <ul style={{paddingLeft: '15px', listStyle:'none', '@media (max-width: 770px)': {paddingLeft: '0px', listStyle: 'devanagari'}}}>
                        <li style={{paddingBottom: '5px'}}>{PRODUCT_TYPES[product.productType].label} price: Rs. {AppUtil.formatNumber(totalPrice)}</li>

                        {selectedVariants &&
                            selectedVariants.filter(vr => vr.priceAddition !== null && vr.priceAddition !== undefined).map(vr => {
                                return <li key={vr.variantId} style={{paddingBottom: '5px'}}>{vr.label}: Rs. {AppUtil.formatNumber(vr.priceAddition)}</li>	
                            })
                        }
                        {
                            (locationExtraCost > 0) &&
                            <li style={{paddingBottom: '5px'}}>{DELIVERY_LOCATION_TYPE[order.locationType].label} Extra cost: Rs. {AppUtil.formatNumber(locationExtraCost)}</li>	
                        }

                        {
                            (deliveryTypeExtraCost > 0) &&
                            <li style={{paddingBottom: '5px'}}>{DELIVERY_TYPE[order.deliveryType].label} Extra cost: Rs. {AppUtil.formatNumber(deliveryTypeExtraCost)}</li>	
                        }

                        {
                            (discountAmount > 0) &&
                            <li style={{paddingBottom: '5px', fontWeight: 'bold', color: '#1b8000', fontSize: '110%'}}>
                                <small><i className="fa fa-tags" aria-hidden="true"></i></small> You received Rs. {AppUtil.formatNumber(discountAmount)} discount!
                            </li>
                        }

                    </ul>
                    <Divider />
                </div>	
            }
        
            <h3 style={[h3Style]}><i className="fa fa-money" aria-hidden="true"></i>  Payment Preference - <b>{paymentInfo}</b></h3>
            <h2 style={[h2Style, {fontWeight: 'bold'}]}>
                Total Amount: 
                Rs. {AppUtil.formatNumber(totalAmount)}
            </h2>

    </React.Fragment>
});

const OrderBasicInfo = Radium(({order, orderState, productType}) => {
    const deliveryTime = AppUtil.getDeliveryTime(productType.val, order.deliveryType);
    const deliveryInfo = <span><i className="fa fa-clock-o" style={{color: "rgb(244, 150, 0)" }}aria-hidden="true"></i> Your order will be delivered within <b>{deliveryTime}</b>.</span>;

    
    return <React.Fragment>
        <Separator style={{display: 'none', '@media (max-width: 770px)': {display: 'block'}}}/>
            <h3 style={h3Style}><i className="fa fa-truck" aria-hidden="true"></i> Deliver To - {order.streetAddress}</h3>
            <h3 style={h3Style}><i className="fa fa-phone" aria-hidden="true"></i> Contact Number - {order.phone}</h3>
            {
                order.additionalNote && 
                <h4 style={h4Style}>- {order.additionalNote}</h4>	
            }

            {orderState === ORDER_PLACED &&
                <div style={{margin: '10px 0'}}>
                    <span>{deliveryInfo}</span>
                </div>
            }
    </React.Fragment>
});

//hook does not work with radium, hence creating separate radium stateless element
const RadiumizedElement = Radium(({order, product, discountCoupon, customerImage, orderState, onClose, onProceedToPay, onConfirm}) => {
    const productType = PRODUCT_TYPES[product.productType];

    let receiptTitle = null, confirmBtn = null, goBackBtn = null;

    goBackBtn = <Button mui="true" variant="default" color="raised" 
                    onClick={() => onClose(orderState === ORDER_PLACED)} 
                    style={{'@media (max-width: 770px)': {flexGrow: '1'}}}>Go Back</Button>;

    const isLoggedIn = SessionStore.getCurrentSession() !== null;

    if(orderState === ORDER_TO_CONFIRM) {
        receiptTitle = <span>You are one-step away from your {productType.label} <i style={{color: '#f8931c'}} className="fa fa-exclamation-circle" aria-hidden="true"></i></span>
        let confirmBtnText = null;
        if(isLoggedIn) confirmBtnText = "Confirm";
        else confirmBtnText = <span><i className="fa fa-user-circle-o" aria-hidden="true"></i> Continue as Guest</span>
        confirmBtn = <Button mui="true" variant="primary" color="raised" 
                    onClick={onConfirm} style={{'@media (max-width: 770px)': {flexGrow: '1'}}}>{confirmBtnText}</Button>

    } else if (orderState === ORDER_CONFIRMED) {
        receiptTitle = <span>Placing your order <i className="fa fa-circle-o-notch fa-spin" style={{color: '#f8931c'}} aria-hidden="true"></i></span>;
        confirmBtn = <Button mui="true" disabled={true} variant="primary" color="raised" 
                    onClick={() => {}} style={{'@media (max-width: 770px)': {flexGrow: '1'}}}>Submitting <i className="fa fa-circle-o-notch fa-spin" style={{color: '#f8931c'}} aria-hidden="true"></i> </Button>
    } else if (orderState === ORDER_PLACED) {
        const paymentPreference = order.paymentPreference;

        let confirmBtnTxt = null, confirmBtnUrl = null;

        if(paymentPreference === 'COD') {
            confirmBtnTxt = "View Order";
            confirmBtnUrl = "/orders";
        } else {
            confirmBtnTxt = "Proceed To Pay";
            confirmBtnUrl = "/orders/checkout?via="+paymentPreference;
        }
            
        confirmBtn = <Button id="viewOrderBtn" mui="true" variant="primary" color="raised" href={confirmBtnUrl} style={{marginLeft: '10px'}}>{confirmBtnTxt}</Button>

        receiptTitle = <span>Order Placed Successfully <i style={{color: 'green'}} className="fa fa-check-circle" aria-hidden="true"></i></span>;

        goBackBtn = <Button mui="true" variant="default" color="raised" 
                    onClick={() => onClose(orderState === ORDER_PLACED)} 
                    style={{'@media (max-width: 770px)': {flexGrow: '1'}}}>Continue Shopping</Button>;
    }

    return <div className='flexColumn' id="purchaseReceipt">
                <div className='flexRow' style={{justifyContent: 'space-between', alignItems: 'center', background: '#dedede', padding: '10px', marginTop: '10px'}}>
                    <span>Call us at <i style={{color: "#f8941c"}} className="fa fa-phone-square" aria-hidden="true"></i> {AppConstants.CONTACT_NUMBER} or WhatsApp at <i style={{color: "green"}} className="fa fa-whatsapp" aria-hidden="true"></i> {AppConstants.WHATS_APP}</span>
				</div>
                
                <div style={{textAlign: 'center'}}>
                    <h2 style={[h2Style, {color: "#646464", margin: '25px 0 0 0'}]}>{receiptTitle}</h2>
                </div>

                <div className="flexRow" id="orderDetail" style={{marginTop: '25px', '@media (max-width: 770px)': {flexDirection: 'column-reverse'}}}>
                    <div style={{flexGrow: 1, textAlign: 'right', borderRight: '1px solid gray', padding: '0 20px', maxWidth: '600px', '@media (max-width: 770px)': {textAlign: 'left', padding: '0 10px', borderRight: 'none'}}}>
                        <OrderBasicInfo order={order} orderState={orderState} productType={productType} />
                        <Divider />

                        {
                            order.orderMetaData &&
                            <React.Fragment>
                                <OrderMetaData orderMetaData={order.orderMetaData} />
                                <Divider />
                            </React.Fragment>
                        }
                        
                        <OrderAmount order={order} product={product} discountCoupon={discountCoupon} />
                        
                        {
                            orderState === ORDER_PLACED && 
                            <div>
                                <h3 style={h3Style}>You can view your orders <A href="/orders">here</A>.</h3>
                                <Divider />
                            </div>
                        }
                        
                        <div className="flexRow" style={{justifyContent: "flex-end", marginTop: '10px'}}>
                            {goBackBtn}
                            {confirmBtn}
                        </div>

                        {
                            !isLoggedIn &&
                            <LoginSignUpBtn />
                        }
                    </div>
                    
                    <div style={{textAlign: 'center', flexGrow: 1, maxWidth: '45%', '@media (max-width: 770px)': {maxWidth: '100%'}}}>
                        <OrderImage order={order} product={product} productType={productType} customerImage={customerImage} />
                    </div>
                </div>

                
			</div>
});

function saveOrderData(order) {
    CacheService.save(AppConstants.USER_ADDRESS_KEY, JSON.stringify({phone: order.phone, 
                        streetAddress: order.streetAddress, 
                        additionalNote: order.additionalNote,
                        locationType: order.locationType}), true);
}

//rename it to OrderConfirmation and move it to views/order 
const OrderConfirmation = ({order, product, discountCoupon, customerImage, onClose}) => {
	if(order === null || product === null)
        return null;
        
    const [orderState, setOrderState ] = useState(ORDER_TO_CONFIRM);
    
    const session = useReduceStore(SessionStore, (store) => store.getCurrentSession(), 
                            () => {
                                //do nothing, if session does not exists
                            }, []);

    function onFormSubmit(success) {
        if(success)
            setOrderState(ORDER_PLACED);
    }

    function onProceedToPay() {
        setOrderState(PROCEED_TO_PAY);
    }

    function onConfirmOrder() {
        try {
            setOrderState(ORDER_CONFIRMED);

            if(!session) {
                saveOrderData(order);
            } else {
                const userType = SessionStore.getCurrentSession().user.userType;
                if(userType !== USER_TYPE.ADMIN && userType !== USER_TYPE.SALES)
                    saveOrderData(order);
            }

            if(!customerImage)
                OrderAPI.placeOrder(order, onFormSubmit);
            else
                OrderAPI.placeCustomOrder(order, customerImage, onFormSubmit);
        } catch(err) {
            setOrderState(ORDER_PLACED);
			console.log("Submit Order Error", err);
            alert("Some error occurred while submitting your order. Please DM us to place the order: "+err.toString());
		}
        
        
    }

    useLayoutEffect(() => {
        window.setTimeout(function() {
            AppUtil.scrollToElement("orderDetail", {block: "center", behavior: 'smooth'});
        }, 10);
    }, []);
    return <RadiumizedElement order={order} product={product} discountCoupon={discountCoupon} 
                                customerImage={customerImage}
                                onClose={onClose} onConfirm={onConfirmOrder}
                                onProceedToPay={onProceedToPay}
                                orderState={orderState} />
};


export default OrderConfirmation;


// WEBPACK FOOTER //
// ./src/views/order/OrderConfirmation.js